
export function parseQueryString(queryString: string) {
    const obj: any = {};

    if (!queryString) {
        return {};
    }

    if (queryString.charAt(0) === '?') {
        queryString = queryString.substring(1);
    }

    queryString.split('&').forEach((part) => {
        const parts = part.split('=');
        const key = decodeURIComponent(parts[0]);
        const value = decodeURIComponent(parts[1]);

        if (key in obj) {
            if (!Array.isArray(obj[key])) {
                obj[key] = [obj[key]];
            }

            obj[key].push(value);
        } else {
            obj[key] = value;
        }
    });

    return obj;
}

interface ToQueryStringOptions {
    excludeEmptyArrays: boolean;
    excludeEmptyStrings: boolean;
}
export function toQueryString(
    obj: any,
    options: ToQueryStringOptions = {
        excludeEmptyArrays: false,
        excludeEmptyStrings: false,
    }
): string {
    var parts: string[] = [];

    Object.keys(obj).forEach((key) => {
        const value = obj[key];
        const encodedKey = encodeURIComponent(key);

        if (value === null || value === undefined) {
            return;
        }
        if (value === '' && options.excludeEmptyStrings) {
            return;
        }

        if (Array.isArray(value)) {
            const arrayValue = Array.from(value);

            if (arrayValue.length === 0) {
                if (!options.excludeEmptyArrays) {
                    parts.push(encodedKey + '=');
                }
                return;
            }

            arrayValue.forEach((item) => {
                parts.push(encodedKey + '=' + encodeURIComponent(item));
            });
        } else {
            parts.push(encodedKey + '=' + encodeURIComponent(value));
        }
    });

    return parts.join('&');
}

export function urlCombine(...parts: string[]) {
    return parts.map((x) => x.replace(/\/+$/, '')).join('/');
}

export function cacheBustParam(): string {
    return `__=${+new Date()}`;
}

export function ensureSafeReturnUrl(url: string) {
    // url.replace(/\/+/gi, '/');

    if (!url) {
        return '';
    }

    return /^(https?:)?\/\//.test(url) ? '' : url;
}
export function replaceUrlNumberIds(url: string) {
    return url.replace(/\/[0-9]+\//g, '/ID/');
}

export function validateSubdomain(subdomain: string) {
    return /^[a-zA-Z0-9-]*$/.test(subdomain);
}

interface UrlParts {
    path: string;
    search?: string;
    hash?: string;
}

function ensurePrefix(prefix: string, s: string) {
    if (!s.startsWith(prefix)) {
        return prefix + s;
    }

    return s;
}

export function buildUrl(parts: UrlParts) {
    let result = parts.path;

    if (parts.search) {
        result += ensurePrefix('?', parts.search);
    }

    if (parts.hash) {
        result += ensurePrefix('#', parts.hash);
    }

    return result;
}